import Client from "./_client";

/**
 * Get topics for CaseMaster problems
 * @returns {Promise} Response data containing topics
 */
export const getCaseMasterTopics = async () => {
  let url = `/casemasterProblem/filter/topics`;

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get topics. Please try again."
    );
  }

  return result?.data;
};

/**
 * Get CaseMaster problems
 * @param {Object} filters - Filter object with topic and other parameters
 * @returns {Promise} Response data containing problems grouped by difficulty
 */
export const getCaseMasterProblems = async (filters) => {
  let url = "/casemasterProblem?";

  Object.keys(filters).forEach((key) => {
    if (filters[key] !== undefined) {
      // Handle array values
      if (Array.isArray(filters[key])) {
        url += `${key}=${filters[key].join(',')}&`;
      } else {
        url += `${key}=${filters[key]}&`;
      }
    }
  });

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get case studies. Please try again."
    );
  }

  return result?.data;
};

/**
 * Get CaseMaster preparation list
 * @returns {Promise} Response data containing user's preparation topics
 */
export const getCaseMasterPreparationList = async () => {
  let url = "/casemasterProblem/preparationList";

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get preparation list. Please try again."
    );
  }

  return result?.data;
};

/**
 * Get a specific CaseMaster problem by ID
 * @param {string} problemId - The ID of the case master problem
 * @returns {Promise} Response data containing the problem details
 */
export const getMyCaseMasterContestList = async (batch) => {
  let url = `/casemasterContest?batch=${batch}`;

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get contest list. Please try again."
    );
  }

  return result?.data?.casemasterContests || [];
};

export const getCaseMasterProblemById = async (problemId) => {
  let url = `/casemasterProblem/${problemId}`;

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get case study. Please try again."
    );
  }

  return result?.data;
};

